import { useFeatureFlag } from './use-feature-flag';
import { Features } from '../../constants/features';
import { useIsSellerFeatureEnabled } from '../../hooks/use-is-seller-feature-enabled';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';

export const useEnableConversationalAnalytics = () => {
  const isFeatureFlagEnabled = useFeatureFlag(FeatureFlagDeclarations.enableConversationalAnalytics);
  const isSellerFeatureEnabled = useIsSellerFeatureEnabled(Features.ConversationalAnalytics);
  return isFeatureFlagEnabled && isSellerFeatureEnabled;
};
